import React, { useEffect, useState } from 'react';
import { paymentsApi } from '../services/api';

function fmt(n) {
  return new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: 'CZK', maximumFractionDigits: 0 }).format(n || 0);
}

export default function Payments() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(false);
  const [msg, setMsg] = useState('');

  function load() {
    setLoading(true);
    paymentsApi.list({ limit: 100 }).then(r => setPayments(r.data)).finally(() => setLoading(false));
  }
  useEffect(() => { load(); }, []);

  async function syncBank() {
    setSyncing(true);
    try {
      const result = await paymentsApi.syncBank();
      setMsg(`Synchronizace hotova: ${result.matched} spárováno, ${result.unmatched} nespárováno z ${result.processed} transakcí`);
      load();
    } catch (err) {
      setMsg(`Chyba: ${err}`);
    } finally {
      setSyncing(false);
    }
  }

  async function sendReminders() {
    const r = await paymentsApi.sendReminders();
    setMsg(`Odesláno ${r.sent} upomínek`);
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">💳 Platby</h1>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn btn-warning" onClick={sendReminders}>📧 Odeslat upomínky</button>
          <button className="btn btn-primary" onClick={syncBank} disabled={syncing}>
            {syncing ? '⏳ Synchronizuji...' : '🏦 Synchronizovat banku'}
          </button>
        </div>
      </div>

      {msg && <div className="alert alert-info">{msg}</div>}

      <div className="card">
        {loading ? <div className="loading-center"><div className="spinner" /></div> : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Datum</th>
                  <th>Objednávka</th>
                  <th>Zákazník</th>
                  <th>Metoda</th>
                  <th>Referenece</th>
                  <th style={{ textAlign: 'right' }}>Částka</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {payments.map(p => (
                  <tr key={p.id}>
                    <td style={{ fontSize: 12, color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>{p.payment_date?.slice(0, 10)}</td>
                    <td style={{ fontWeight: 600 }}>{p.order_number || '—'}</td>
                    <td>{p.customer_name || p.counterparty_name || '—'}</td>
                    <td style={{ fontSize: 12 }}>
                      {{ bank: '🏦 Banka', cash: '💵 Hotovost', card: '💳 Karta' }[p.method] || p.method}
                    </td>
                    <td style={{ fontSize: 12, color: 'var(--text-muted)' }}>{p.variable_symbol || p.reference || '—'}</td>
                    <td style={{ textAlign: 'right', fontWeight: 700, color: 'var(--green)' }}>{fmt(p.amount)}</td>
                    <td>
                      <span className={`badge ${p.order_id ? 'badge-paid' : 'badge-waiting'}`}>
                        {p.order_id ? '✓ Spárováno' : '⚠ Nespárováno'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {payments.length === 0 && <div className="empty-state">Žádné platby</div>}
          </div>
        )}
      </div>
    </div>
  );
}
